import { render, staticRenderFns } from "./TutorialFluxoDialog.vue?vue&type=template&id=86d7005a&scoped=true"
import script from "./TutorialFluxoDialog.vue?vue&type=script&lang=js"
export * from "./TutorialFluxoDialog.vue?vue&type=script&lang=js"
import style0 from "./TutorialFluxoDialog.vue?vue&type=style&index=0&id=86d7005a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d7005a",
  null
  
)

export default component.exports